// extracted by mini-css-extract-plugin
module.exports = {"el":"index-module--el--1NeZd","description":"index-module--description--cSzq0","title":"index-module--title--3zp3E"};